import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import * as d3 from 'd3';

import ProvinceBox from './provinceBox'
const styles = theme => ({
  card: {
    display: 'flex column',
    margin: 0,
    borderColor: 'rgba(255,255,255,0)!important',
    boxShadow:'0px 0px 0px 0px rgba(255,255,255,0)!important',
    backgroundColor: '#f3f3f3',
  },
  cardHeader: {
    backgroundColor: '#069999',
    color: '#fff',
    padding: '10px',
    fontFamily: 'Nunito Sans SemiBold!important',
    textAlign: 'left',
    fontSize: '16pt',
    borderRadius:'10px',
    minHeight:'80px',
    maxHeight:'80px',
  },
  cardContent: {
    padding: '0!important',
    marginTop:'20px;',
    height:'390px',
  },
});

function ProvinceBoxCard(props) {
  const { classes } = props;

  let energyType
  switch (props.lang) {
    case "de":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "Solar-, Onshore- und Offshore-Wind"
              : "Solar- und Onshore-Wind"
          )
            : (
              props.currentTech.windOffshore ?
                "Solar- und Offshore-Wind"
                : "Solar"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "Onshore- und Offshore-Wind" :
                "Onshore-Wind"
            )
              : "Offshore-Wind"
          )
      )
      break
    case "en":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "Solar,onshore and offshore wind"
              : "Solar and onshore wind"
          )
            : (
              props.currentTech.windOffshore ?
                "Solar and offshore wind"
                : "Solar"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "Onshore and offshore wind" :
                "Onshore wind"
            )
              : "Offshore wind"
          )
      )
      break
    case "fr":
    default:
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "solaire, éolienne onshore et offshore"
              : "solaire et éolienne onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "solaire et éolienne offshore"
                : "solaire"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "éolienne onshore et offshore" :
                "éolienne onshore"
            )
              : "éolienne offshore"
          )
      )
  }

  let cardHeaderTitle
  let dateInfo
  if (props.currentMode === 'realtime') {
    let formattedDay
    switch (props.lang) {
      case "de":
        formattedDay = d3.timeFormat('%e. %B %Y')(props.selectedDate)
        dateInfo = "am " + formattedDay
        break
      case "en":
        formattedDay = d3.timeFormat('%e %B %Y')(props.selectedDate)
        dateInfo = formattedDay
        break
      case "fr":
      default:
        formattedDay = d3.timeFormat('%e %B %Y')(props.selectedDate)
        dateInfo = " le " + formattedDay
    }
  }
  else {
    let formattedYear = props.yearSelected
    switch (props.lang) {
      case "de":
        dateInfo = formattedYear
        break
      case "en":
        dateInfo = formattedYear
        break
      case "fr":
      default:
        dateInfo = " en " + formattedYear
    }
  }
  switch (props.lang) {
    case "de":
      cardHeaderTitle = energyType + "energie nach Provinz " + dateInfo
      break
    case "en":
      cardHeaderTitle = energyType + " per province, " + dateInfo
      break
    case "fr":
    default:
      cardHeaderTitle = "Énergie " + energyType + " par province " + dateInfo
  }


  return (
    <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          disableTypography
          title={cardHeaderTitle}
        />

        <CardContent className={classes.cardContent}>
          <ProvinceBox
            lang={props.lang}
            provinceData={props.provinceData}
            provinceDataWithoutOffshore={props.provinceDataWithoutOffshore}
            currentTech={props.currentTech}
            currentMode={props.currentMode}
            daySelected={props.daySelected}
            yearSelected={props.yearSelected}
            
            currentFilter={props.currentFilter}
            offshoreEnergyProduction={props.offshoreEnergyProduction}
          />
        </CardContent>
      </Card>
  );
}

ProvinceBoxCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProvinceBoxCard);
